module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upper-subpanel--inside"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('DrugInfo')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "confirm-layout"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n        此藥物總數量: " + _vm._s(_vm.selectedDrugTotalAmount) + " \n        "), _c('span', {
    staticClass: "float-right"
  }, [_vm._v("(新增位置: " + _vm._s(_vm.selectedDevicesID.indexOf(_vm.currentDevice.id.toString()) + 1) + "/" + _vm._s(_vm.selectedDevicesID.length) + ")")])]), _vm._v(" "), (_vm.currentProgress === 'confirm') ? _c('confirmFlow', {
    attrs: {
      "confirmProgress": _vm.confirmProgress
    },
    on: {
      "confirmationFinish": _vm.getConfirmData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'setMinStorage') ? _c('set-min-storage', {
    attrs: {
      "defaultAmount": _vm.minStorage,
      "canBeZero": true,
      "inputLabel": '更新安全存量'
    },
    on: {
      "setNum": _vm.getMinStorage
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f8be82c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateDrugFlow/MultiFlow.vue
// module id = 1556
// module chunks = 1